import React, { Component } from 'react';
// import Wrp from '../../../hoc/Wrp/Wrp';
import {getDateFormat} from '../../../../Utils/UserFunctions';
import moment from 'moment';

class UserCard extends Component {
    
    render () {
        const {colData,id} = this.props;
        let convertTime;
        convertTime = moment(colData.time, 'YYYY-MM-DDTHH:mm:ss', true).format(getDateFormat());
        return(
            <td key={id} className="card-list p-0">
            <div className="item-list" >
				<div className="avatar-xs" style={{marginLeft:'5px'}}>
				    <img src={colData.img} alt="..." className="avatar-img rounded-circle" />
				</div>
				<div className="info-user ml-3">
			    <div className="username">{(colData.username) ? colData.username:"Unknown"}</div>
				<div className="status">{(colData.time) ? convertTime:"DD/MM/YYYY"}</div>
			    </div>			 
			</div>
            </td>
        );
    }
}

export default UserCard;